import { useMemo } from 'react';
import { Job } from '@core/generated/gql-types';
import {
  TemplateTerm,
  useTemplateStore,
} from '@core/template/useTemplateStore';
import PercentageDifference from './PercentageDifference';

interface ActiveWorkersProps {
  filledJobs: Job[];
  priorWeekFilledJobs: Job[];
  comparisonLabel: string;
}

const ActiveWorkers = ({
  filledJobs,
  priorWeekFilledJobs,
  comparisonLabel,
}: ActiveWorkersProps) => {
  const { getTerm } = useTemplateStore();

  const getUserIdsFromJobs = (jobs: Job[]): Set<string> => {
    const users = new Set<string>();
    jobs.forEach((job) => {
      if (job.userId) {
        users.add(job.userId);
      }
    });
    return users;
  };

  const activeWorkers = useMemo(
    (): Set<string> => getUserIdsFromJobs(filledJobs),
    [filledJobs],
  );

  const priorWeekActiveWorkers = useMemo(
    (): Set<string> => getUserIdsFromJobs(priorWeekFilledJobs),
    [priorWeekFilledJobs],
  );

  return (
    <div className="flex h-auto min-h-[140px] flex-row items-center rounded-xl bg-white p-4 shadow">
      <div className="flex h-full flex-1 flex-col justify-between">
        <div className="text-md font-semibold">
          Active {getTerm(TemplateTerm.WORKER, true)}
        </div>
        <div className="mb-2 text-3xl font-medium">{activeWorkers.size}</div>

        <PercentageDifference
          currentValue={activeWorkers.size}
          priorValue={priorWeekActiveWorkers.size}
          comparisonLabel={comparisonLabel}
        />
      </div>
    </div>
  );
};

export default ActiveWorkers;
